import React from "react";
import "./resultsection.css";

const CenterTitleSection = () => {
  return (
    <section className="cts-section">
      <div className="cts-container">

        <h2 className="cts-main-title">Welcome to the NIECCE Exam Result page.
Here, you can easily check your exam results by entering your Registration/hall ticket number.</h2>

        <p className="cts-subtitle">The space to enter Hallticket Number will load in a few seconds....</p>

        <div className="cts-iframe-wrapper">
          <iframe
            src="https://dashboard.liltriangle.com/exam-result"
            title="Exam Result"
            className="cts-iframe"
            frameBorder="0"
            allowFullScreen
          ></iframe>
        </div>

      </div>
    </section>
  );
};

export default CenterTitleSection;
